import React from 'react';
import {Link} from 'react-router';

import {Text} from '@albert-io/atomic';

// legacy Mandark student shape — only the fields the card renders
export interface OverviewStudent {
  getId: () => string;
  getFullName: () => string;
  getAccuracyFromMeta: () => number;
  getMeta: () => {getCountOfGuesses: () => number};
}

interface StatRowProps {
  value: React.ReactNode;
  label: string;
}

// value left, label right — matching the legacy StudentColumns stat layout.
const StatRow = ({value, label}: StatRowProps) => (
  <div className='flex items-center gap-x0-half'>
    <Text size='s' color='secondary'>
      {value}
    </Text>
    <Text size='s' color='secondary'>
      {label}
    </Text>
  </div>
);

interface Props {
  student: OverviewStudent;
  classroomId: string;
}

const StudentCardBase = ({student, classroomId}: Props) => (
  <Link
    to={`/classes/${classroomId}/students/detail/${student.getId()}/overview`}
    className='flex flex-col gap-x0-half rounded-x1 border border-primary background-primary p-x0 px-x2 py-x1 no-underline hover:background-primary-hover active:background-primary-pressed'
  >
    <Text className='font-semibold content-primary'>{student.getFullName()}</Text>
    <StatRow value={student.getMeta().getCountOfGuesses()} label='questions' />
    <StatRow value={`${student.getAccuracyFromMeta()}%`} label='raw accuracy' />
  </Link>
);

// Rendered up to a few hundred times in the mastery grid
export const StudentCard = React.memo(StudentCardBase);
